import React, { useState } from 'react';
import { Box, Grid, InputBase } from '@material-ui/core';
import BoxCenter from '../components/BoxCenter';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
  root: {
    transform: ({ scale }) => `scale(${window.devicePixelRatio * scale})`,
    pointerEvents: 'all',
  },
  submitButton: {
    backgroundColor: 'transparent',
    backgroundImage: 'url(images/customize/btn_darkblue_normal.png)',
    backgroundSize: 'contain',
    border: 'none',
    color: 'white',
    height: 50,
    paddingBottom: 30,
    outline: 'none',
    fontFamily: 'PJ_WangNgan',
    fontSize: '32px',
    width: 105,
    '&:active': {
      paddingBottom: 25,
      backgroundImage: 'url(images/customize/btn_darkblue_active.png)',
    },
  },
  textField: {
    backgroundImage: 'url(images/customize/framing_3.png)',
    height: 50,
    marginLeft: 90,
    padding: theme.spacing(1),
    width: 267,
  },
}));
const Customization = ({ onSubmit, scale, name: nameValue }) => {
  const { root, submitButton, textField } = useStyles({ scale });
  const [name, setName] = useState(nameValue);
  const [disabled, setDisable] = useState(false);
  const handleChangeTextField = ({ target }) => {
    setName(target.value);
  };
  const handleClickConfirm = () => {
    if (name !== '') {
      onSubmit(name);
    }
  };
  return (
    <BoxCenter>
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="Center"
        position="absolute"
        top="85%"
        className={root}
      >
        <Grid container justify="center" alignItems="center" spacing={2}>
          <Grid item>
            <InputBase
              className={textField}
              name="name"
              value={name}
              onChange={handleChangeTextField}
              placeholder={'ชื่อ-นามสกุล'}
              inputProps={{
                style: { textAlign: 'center' },
              }}
              onFocus={() => setDisable(true)}
              onBlur={() => setDisable(false)}
            />
          </Grid>
          <Grid item>
            <button
              onClick={handleClickConfirm}
              className={submitButton}
              disabled={
                navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
                  ? disabled
                  : false
              }
            >
              ยืนยัน
            </button>
          </Grid>
        </Grid>
      </Box>
    </BoxCenter>
  );
};

export default Customization;
